import React from 'react';
import { Box, IconButton } from '@mui/material';
import { FaSearch } from 'react-icons/fa';

const SearchToggleInput = ({
  active,
  clearAriaLabel,
  children,
  iconButtonSx,
  inputRef,
  inputStyle,
  onChange,
  onClear,
  onToggle,
  placeholder = 'Search',
  showInput,
  toolbarSx,
  trailingContent,
  value,
  wrapperStyle,
}) => (
  <Box sx={{ width: '100%' }}>
    <Box sx={toolbarSx}>
      {children}
      <IconButton size="small" onClick={onToggle} sx={iconButtonSx}>
        <FaSearch color={active ? 'blue' : 'gray'} />
      </IconButton>
      {trailingContent}
    </Box>
    {showInput ? (
      <div
        style={{
          position: 'relative',
          marginTop: 6,
          display: 'inline-block',
          width: '100%',
          ...wrapperStyle,
        }}
      >
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          autoCapitalize="none"
          style={{
            width: '100%',
            fontSize: '16px',
            padding: '6px 30px 6px 8px',
            borderRadius: '4px',
            border: '1px solid rgba(0,0,0,0.23)',
            ...inputStyle,
          }}
        />

        {value ? (
          <button
            aria-label={clearAriaLabel}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onClear();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              position: 'absolute',
              right: 6,
              top: '50%',
              transform: 'translateY(-50%)',
              border: 'none',
              background: 'transparent',
              padding: '2px 6px',
              cursor: 'pointer',
              fontSize: 16,
              lineHeight: 1,
            }}
          >
            ×
          </button>
        ) : null}
      </div>
    ) : null}
  </Box>
);

export default SearchToggleInput;
